(() => {
  if (customElements.get('asamo-checkout-now')) return;
  customElements.define('asamo-checkout-now', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.form = this.closest('form');
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="alert"]');
      this.update = () => {
        const add = this.form?.querySelector('add-to-cart-component button[type="submit"]');
        const disabled = !!this.busy || !add || add.disabled;
        if (this.button.disabled !== disabled) this.button.disabled = disabled;
        if (add) {
          const style = getComputedStyle(add);
          this.style.setProperty('--checkout-bg', style.backgroundColor);
          this.style.setProperty('--checkout-color', style.color);
          this.style.setProperty('--checkout-radius', style.borderRadius);
          this.button.style.font = style.font;
          this.button.style.letterSpacing = style.letterSpacing;
          this.button.style.textTransform = style.textTransform;
        }
      };
      this.update();
      this.observer = new MutationObserver(this.update);
      if (this.form) this.observer.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'class'] });
      this.button.addEventListener('click', () => this.checkout(), { signal: this.abort.signal });
    }
    async checkout() {
      if (this.busy || !this.form || this.button.disabled || !this.form.reportValidity()) return;
      const data = new FormData(this.form);
      if (!data.get('id')) return;
      this.busy = true;
      this.error.hidden = true;
      this.button.textContent = 'Opening checkout…';
      this.button.setAttribute('aria-busy', 'true');
      this.update();
      try {
        const response = await fetch(this.dataset.addUrl, { method: 'POST', body: data, credentials: 'same-origin', headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item. Please check your selection.');
        window.location.assign(this.dataset.checkoutUrl);
      } catch (error) {
        this.error.textContent = error.message || 'Unable to connect. Please try again.';
        this.error.hidden = false;
        this.busy = false;
        this.button.textContent = 'Check out now';
        this.button.removeAttribute('aria-busy');
        this.update();
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
})();
